import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface NavTabsProps {
  items: Array<{ label: string; to: string }>;
  className?: string;
}

interface IndicatorStyle {
  left: number;
  width: number;
}

export default function NavTabs({ items, className }: NavTabsProps) {
  const [indicator, setIndicator] = useState<IndicatorStyle>({ left: 0, width: 0 });
  const location = useLocation();
  const tabsRef = useRef<Record<string, HTMLAnchorElement | null>>({});

  useEffect(() => {
    const currentPath = location.pathname;
    const active = items.find((it) => currentPath.includes(it.to));
    if (active) {
      const el = tabsRef.current[active.to];
      if (el) {
        setIndicator({ left: el.offsetLeft, width: el.offsetWidth });
      }
    }
  }, [location.pathname, items]);

  return (
    <div className={`relative w-full border-b border-gray-300 ${className ?? ''}`}>
      <div className="flex gap-5 items-center">
        {items.map(({ label, to }) => (
          <NavLink
            key={to}
            to={to}
            end
            ref={(el) => (tabsRef.current[to] = el)}
            className={({ isActive }) =>
              [
                'px-2 py-3 3xl:py-4 4xl:py-5 cursor-pointer relative text-base xl:text-[18px] font-family-outfit leading-[24px] transition-colors duration-200',
                isActive ? 'text-primary-900 font-[500]' : 'text-gray-500 hover:text-primary-500',
              ].join(' ')
            }
          >
            {label}
          </NavLink>
        ))}
      </div>
      <div
        className="absolute bottom-0 h-[4px] bg-[#587EFF] transition-all duration-300 ease-in-out rounded-[4px]"
        style={{ left: indicator.left, width: indicator.width }}
      />
    </div>
  );
}
